// API handlers for FlipPanel sections
import {
  get_seo_article_headline_for_single_keyword,
  submitKeywordLevelContentOutlineRequest,
  submitPageLevelContentOutlineRequest,
  submitContentOutlineDraftRequest,
  submitAiOverviewByKeywordRequest,
  submitAiOverviewByContentRequest
} from 'services/buddyXApiHubService';

export const handleArticleHeadlineAPI = async (data, onInsufficientCredits) => {
  try {
    const apiData = {
      keywords: [data.keyword],
      brand_name: data.brand || ""
    };
    
    const result = await get_seo_article_headline_for_single_keyword(apiData, onInsufficientCredits);
    return { success: true, data: result };
  } catch (error) {
    console.error("Article headline generation error:", error);
    return { success: false, error: error.message };
  }
};

export const handleContentOutlineAPI = async (data, selectedKeyword, onInsufficientCredits) => {
  try {
    let result;
    
    if (data.sourceType === "keyword") {
      const apiData = {
        title: data.title,
        primary_keyword: data.keyword,
        brand: data.brand,
        model: data.model,
        word_count: data.wordCount
      };
      result = await submitKeywordLevelContentOutlineRequest(apiData, "keyword_level_content_outliner", onInsufficientCredits);
    } else if (data.sourceType === "url") {
      const apiData = {
        url: data.url,
        primary_keyword: data.keyword,
        brand: data.brand,
        model: data.model,
        word_count: data.wordCount,
      };
      result = await submitPageLevelContentOutlineRequest(apiData, "page_level_content_outliner", onInsufficientCredits);
    }
    
    return { success: true, data: result };
  } catch (error) {
    console.error("Content outline generation error:", error);
    return { success: false, error: error.message };
  }
};

export const handleContentDraftAPI = async (data, onInsufficientCredits) => {
  try {
    const apiData = {
      seo_outline: data.seo_outline,
      primary_keyword: data.primary_keyword,
      model: "writer_1"
    };
    let action = data.sourceType === "url" ? "page_level_content_draft" : "keyword_level_content_draft";
    const result = await submitContentOutlineDraftRequest(apiData, action, onInsufficientCredits);
    return { success: true, data: result };
  } catch (error) {
    console.error("Content draft generation error:", error);
    return { success: false, error: error.message };
  }
};

export const handleAiOverviewAPI = async (data, onInsufficientCredits) => {
  try {
    const apiData = {
      primary_keyword: data.keyword,
      brand: data.brand || "",
      no_queries: data.noQueries
    };
    
    const result = await submitAiOverviewByKeywordRequest(apiData, "ai_overview_keyword", onInsufficientCredits);
    return { success: true, data: result };
  } catch (error) {
    console.error("AI overview generation error:", error);
    return { success: false, error: error.message };
  }
};

export const handleAiOverviewByContentAPI = async (data, onInsufficientCredits) => {
  try {
    const apiData = {
      text: data.text,
      no_queries: data.no_queries
    };
    
    const result = await submitAiOverviewByContentRequest(apiData, "ai_overview_content", onInsufficientCredits);
    return { success: true, data: result };
  } catch (error) {
    console.error("AI overview by content generation error:", error);
    return { success: false, error: error.message };
  }
};
